type AnalyticsTrack = (
  eventName: string,
  payload?: Record<string, unknown>
) => void;

type AnalyticsWindow = Window & {
  analytics?: {
    track?: AnalyticsTrack;
  };
};

export const trackTourOnboardingEvent = (
  eventName: string,
  payload: Record<string, unknown> = {}
) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedEventName = `product_tour_${eventName}`;
  const analyticsWindow = window as AnalyticsWindow;
  analyticsWindow.analytics?.track?.(normalizedEventName, payload);

  window.dispatchEvent(
    new CustomEvent('product-tour:onboarding-event', {
      detail: {
        eventName: normalizedEventName,
        payload,
      },
    })
  );
};
